import React from 'react'
import { Dropdown } from '@wiggui/ds/Dropdown'
import { GoogleIcon } from '@wiggui/ds/GoogleIcon'
import { DropdownKeys } from '@/modules/results/components/Filters'
import { OperationTypes } from '../OperationTypes'
import Transition from '@wiggui/ds/Transition'
import { Skeleton } from '@wiggui/ds/Skeleton'

interface IOption {
  [key: string]: string
}

interface IProps {
  isLoading?: boolean
  isOpen: boolean
  operationTypeData?: IOption
  onChangeOperationType: (value: string) => void
  setIsOpen: ({
    isOpen,
    dropdownKey
  }: {
    isOpen: boolean
    dropdownKey: DropdownKeys
  }) => void
}
export const OperationTypeDropdow = ({
  operationTypeData,
  isOpen,
  isLoading,
  setIsOpen,
  onChangeOperationType
}: IProps) => {
  const onClose = () => {
    setIsOpen({ isOpen: false, dropdownKey: 'isOpenOperationType' })
  }
  const onSetIsOpen = (isOpen: boolean) => {
    setIsOpen({ isOpen, dropdownKey: 'isOpenOperationType' })
  }
  return (
    <Dropdown
      positionX={25}
      isOpen={isOpen}
      setIsOpen={onSetIsOpen}
      onClose={onClose}
    >
      <Dropdown.Trigger
        className={`flex flex-col items-start justify-center px-4 py-[6px] rounded-full cursor-pointer ${
          isOpen
            ? 'bg-white shadow-[0px_3px_6px_0px_rgba(34,34,34,0.16)]'
            : 'hover:bg-surface-strokes'
        }`}
      >
        <p className="text-secondary text-xs">Operación</p>
        {operationTypeData && !isLoading && (
          <p className="flex items-center text-base text-primary gap-1">
            {operationTypeData?.label}
            <GoogleIcon className="text-base" name={operationTypeData?.icon} />
          </p>
        )}
        {isLoading && (
          <Skeleton
            height="h-6"
            width="w-[62px]"
            className="min-w-full min-h-full"
          />
        )}
      </Dropdown.Trigger>
      <Dropdown.Menu className="flex w-auto md:min-w-[522px] md:w-[522px] p-4 gap-4 justify-center rounded-xl border border-surface-strokes shadow-[0px_3px_34px_-2px_rgba(34,34,34,0.20)] bg-white">
        <Transition className="!flex gap-4 w-full h-full" show={isOpen}>
          <OperationTypes
            onChangeOperationType={onChangeOperationType}
            operationType={operationTypeData?.value}
          />
        </Transition>
      </Dropdown.Menu>
    </Dropdown>
  )
}
